import { render } from "./Recommended.vue?vue&type=template&id=4d2df964&scoped=true&ts=true"
import script from "./Recommended.vue?vue&type=script&lang=ts"
export * from "./Recommended.vue?vue&type=script&lang=ts"

import "./Recommended.vue?vue&type=style&index=0&id=4d2df964&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2df964"]])

export default __exports__